import '../scss/occs.scss'
import '../scss/libraries.scss'
import '../scss/all.combined.scss'

import { cmsService } from './content'
import { onWindowResize, scrollbarWidthUnits, verticalHeightUnits, setDebugMode, isDev } from './content/utilities'

import { App } from './App'
import { initializeGoogleTags } from './content/services/google-tag-manager'
import { LoadChatbot, LoadRum24x7 } from './thirdPartyScripts'
import { NavigateFunction } from 'react-router-dom'
import React, { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import { init } from './init'

declare global {
    interface Window {
        // useHistory: History<any>
        navigate: NavigateFunction
    }
}

import('@vista-digital/occ-ui/icons/svg-sprite').then(() => {
    cmsService.initialize().then(occConfigurationApi => {
        init(occConfigurationApi)

        const rootDiv = document.getElementById('root')
        if (rootDiv) {
            const root = createRoot(rootDiv)
            root.render(createElement(App))
        }
    })
})

// In dev mode, global is only an empty object. In builds, global is equal to the window object.
// If global is not set, the braintree payment connector will fail to load.
if (isDev()) {
    window.global = window
}
